import Vue from 'vue'
import Vuex from 'vuex'
import topBar from './store/modules/topBar'
import common from './store/modules/common'
import individual from './store/modules/individual'
import domain from './store/modules/domain'
import logininfo from './store/modules/logininfo'
import downloadsize from './store/modules/downloadsize'

import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    topBar,
    common,
    individual,
    domain,
    logininfo,
    downloadsize
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  plugins: [createPersistedState({
    key: 'aidy-logininfo',
    paths: ['logininfo'],
    storage: window.sessionStorage
  })]
})